import { useEffect, useState } from "react";

/**
 * Returns milliseconds elapsed since `startedAt`, updating every second.
 * Used to keep countdown timers fresh in impersonation session UIs.
 */
export function useSessionTimer(startedAt: number): number {
  const [elapsed, setElapsed] = useState(Date.now() - startedAt);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsed(Date.now() - startedAt);
    }, 1_000);

    return () => {
      clearInterval(interval);
    };
  }, [startedAt]);

  return elapsed;
}
